import { createFileRoute, Outlet, redirect } from "@tanstack/react-router";
import z from "zod";

import { getSessionStoreState } from "@/stores";

export const GuestLayout = () => {
  return (
    <main className="h-dvh" id="main-content" tabIndex={-1}>
      <Outlet />
    </main>
  );
};

export const Route = createFileRoute("/_guest")({
  validateSearch: z.object({
    redirect: z.string().optional().catch(""),
  }),
  beforeLoad: ({ search }) => {
    const { session } = getSessionStoreState();

    if (session?.token) {
      throw redirect({ to: search.redirect ?? "/" });
    }
  },
  component: GuestLayout,
});
